import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoPopup = () => {
  const [show, setShow] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip if already dismissed this session
    if (sessionStorage.getItem('ss_promo_dismissed')) return;

    const fetchPopup = async () => {
      try {
        const { data } = await axios.get(`${API}/promo-popup`);
        if (data.enabled && data.image_url) {
          setImageUrl(data.image_url);
          setShow(true);
        }
      } catch {
        // Silently fail — popup is non-critical
      }
    };
    fetchPopup();
  }, []);

  const dismiss = () => {
    setShow(false);
    sessionStorage.setItem('ss_promo_dismissed', '1');
  };

  if (!show || !imageUrl || pathname.startsWith('/admin')) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label="Promotional offer"
      data-testid="promo-popup"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={dismiss} aria-hidden="true" />

      {/* Content */}
      <div className="relative max-w-lg w-full animate-in fade-in zoom-in-95 duration-300">
        <button
          onClick={dismiss}
          className="absolute -top-3 -right-3 z-10 w-9 h-9 rounded-full bg-white text-black flex items-center justify-center shadow-lg hover:bg-[#DEA193] hover:text-white transition-colors"
          aria-label="Close promotional popup"
          data-testid="promo-popup-close"
        >
          <X className="w-5 h-5" />
        </button>

        <img
          src={imageUrl}
          alt="Promotional offer"
          className="w-full h-auto rounded-lg shadow-2xl"
          data-testid="promo-popup-image"
          onClick={dismiss}
        />
      </div>
    </div>
  );
};
